import { useQuery } from '@tanstack/react-query'
import { useSession } from '@/lib/auth-client.ts'
import { fetchCurrentUser } from './api.ts'

export function useCurrentUser() {
  const session = useSession()

  return useQuery({
    queryKey: ['me'],
    queryFn: fetchCurrentUser,
    enabled: Boolean(session.data?.user),
    staleTime: 60_000,
  })
}
